<script setup lang="ts">
const $attrs = useAttrs()

withDefaults(defineProps<{
    w?: string
    debug?: boolean
  }>(), { 
    w: '', 
    debug: false,
  })


const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})

const wrap = ref()

const slots = useSlots()
const section = ref()
defineExpose({
  section
})
</script>

<template>
  <div ref="section" class="m-section" :class="{ 
    'debug': debug
  }">
    <slot name="bglayer" v-if="slots.bglayer" />
    <Wrap ref="wrap" 
      :class="w"
      v-bind="filteredAttrs">
      <slot />
    </Wrap>
  </div>
</template>

<style lang="scss" scoped>
.m-section {


  &.relative {
    position: relative;
    > .m-wrap {
      position: relative;
    }
  }

  &.h-full {
    height: 100%;
  }
  &:slotted(> .bg-layer) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  > .m-wrap {
    width:100%;
    /* display:grid; */
    /*grid-auto-flow: column; */

    .sec-bg-pad {
			position:absolute;
			top:0;
			left:0;
			height:100%;
			width:33%;
			background: var(--shade-1);

			&.right {
				left: auto;
				right:0;
				left:auto;
			}
		}
    

    /* Represents the first child column of this element */
    &:slotted(> .m-col) {
      /* box-shadow: inset 0 0 0 1px black; */
    }
    &:slotted(> .m-col) {
      /* box-shadow: inset 0 0 0 1px black; */
    }

    &.snap {
      /* @include mq($until: t) { */
        &:slotted(> .m-col) {
          grid-column: 1/-1;
        }
      /* } */
    }
  }

  &.debug {
    >.m-wrap {
      box-shadow: inset 0 0 0 1px blue;
      :deep(.m-col) {
        box-shadow: inset 0 0 0 1px red;
      }
    }
  }
}
</style>
